function getCartDataFromStorage() {
  const stored = sessionStorage.getItem("quoteCart");
  return stored ? JSON.parse(stored) : [];
}

function calculateSubtotal(products) {
  return products.reduce((sum, p) => sum + (p.price / 100) * p.quantity, 0);
}

async function fetchShippingAndTax(subtotal) {
  let shipping = null;
  let taxes = null;

  const storedShipping = sessionStorage.getItem("selectedShippingRate");
  if (storedShipping) {
    shipping = parseFloat(storedShipping);
  }

  const storedTax = localStorage.getItem("quoteTax");
  if (storedTax) {
    try {
      const quoteTax = JSON.parse(storedTax);
      taxes = parseFloat(quoteTax.amount || "0");
    } catch (err) {
      console.warn("Invalid quoteTax in localStorage:", err);
    }
  }

  return { shipping, taxes };
}

function formatCurrency(amount) {
  return `${amount.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    })}`;
}

async function updateCartSummary() {
  const products = getCartDataFromStorage();

  const hasPendingQuoteItem = products.some(p => p.price === 0);
  const subtotal = calculateSubtotal(products);

  const subtotalEl = document.getElementById("subtotal") || document.getElementById("quote-subtotal");
  const shippingEl = document.getElementById("shipping") || document.getElementById("quote-shipping");
  const taxesEl = document.getElementById("taxes") || document.getElementById("quote-taxes");
  const totalEl = document.getElementById("total") || document.getElementById("quote-total");

  // ✅ Set default: taxes = "Pending Quote"
  taxesEl.textContent = "Pending Quote";

  const { shipping, taxes } = await fetchShippingAndTax(subtotal);

  let total = subtotal;

  // ✅ Get country from quoteCustomerInfo
  const customerInfoRaw = sessionStorage.getItem("quoteCustomerInfo");
  let customerCountry = "";
  if (customerInfoRaw) {
    try {
      const customerInfo = JSON.parse(customerInfoRaw);
      customerCountry = customerInfo.country?.toLowerCase() || "";
    } catch (e) {
      console.warn("Invalid quoteCustomerInfo:", e);
    }
  }

  // ✅ Subtotal logic
  if (hasPendingQuoteItem) {
    subtotalEl.textContent = "Pending Quote";
  } else {
    subtotalEl.textContent = formatCurrency(subtotal);
  }

  // ✅ Shipping logic
  if (shipping === null) {
    shippingEl.textContent = "Pending Quote";
  } else {
    shippingEl.textContent = formatCurrency(shipping);
    total += shipping;
  }

  // ✅ Taxes logic with country override AFTER setting "Pending Quote"
  if (customerCountry && customerCountry !== "us") {
    taxesEl.textContent = "Tax Not Applicable";
  } else if (taxes !== null && taxes > 0) {
    taxesEl.textContent = formatCurrency(taxes);
    total += taxes;
  }
  // If country is US and tax is 0 or null → "Pending Quote" stays

  // ✅ Total logic
  if (hasPendingQuoteItem) {
    totalEl.textContent = "Pending Quote";
  } else {
    totalEl.textContent = formatCurrency(total);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  sessionStorage.removeItem("selectedShippingRate");
  localStorage.removeItem("quoteTax");

  updateCartSummary();
  setupNotesSaving();
  setupAddToCartButton();
});

function setupNotesSaving() {
  const notesTextarea = document.getElementById("quote-notes");
  if (!notesTextarea) {
    console.warn("quote-notes textarea not found");
    return;
  }
  const savedNotes = sessionStorage.getItem("quoteNotes");
  if (savedNotes) {
    notesTextarea.value = savedNotes;
  }

  let saveTimeout;
  notesTextarea.addEventListener("input", () => {
    clearTimeout(saveTimeout);
    saveTimeout = setTimeout(() => {
      sessionStorage.setItem("quoteNotes", notesTextarea.value);
    }, 500);
  });
  notesTextarea.addEventListener("blur", () => {
    clearTimeout(saveTimeout);
    sessionStorage.setItem("quoteNotes", notesTextarea.value);
  });
}

function setupAddToCartButton() {
  const addToCartBtn = document.getElementById('add-all-to-cart');

  addToCartBtn.addEventListener("click", async (e) => {
    e.preventDefault();
    addToCartBtn.disabled = true;
    addToCartBtn.style.opacity = "0.6";
    addToCartBtn.textContent = "Adding to Cart...";
    
    try {
      const result = await window.syncQuoteCartToShopifyCart();
      if (result && result.success) {
        // Check that there are valid products to be added to cart
        window.clearQuoteStorage(false); // Clear everything including submittedQuoteCart
        window.location.href = "/checkout";
      }
      
    } catch (error) {
      console.error("❌ Error adding items to cart:", error);
      addToCartBtn.disabled = false;
      addToCartBtn.style.opacity = "1";
      addToCartBtn.textContent = "Add All to Cart";
      alert("There was an error adding items to your cart. Please try again.");
    }
  });
}

function showSubmittedQuotePage() {
  console.log("Transforming quote modal to read-only view...");
  transformShippingInputsToText();
  hideInteractiveElements();
  transformCartItemsToReadOnly();
  transformNotesToReadOnly();
  showSelectedShippingOption();
  updateHeaderForConfirmation();
}

function transformShippingInputsToText() {
  const customerInfo = JSON.parse(sessionStorage.getItem("quoteCustomerInfo") || "{}");
  const fieldsToTransform = [
    { id: "quote-email", value: customerInfo.email || "" },
    { id: "quote-first-name", value: customerInfo.firstName || "" },
    { id: "quote-last-name", value: customerInfo.lastName || "" },
    { id: "quote-company", value: customerInfo.company || "" },
    { id: "quote-address", value: customerInfo.address || "" },
    { id: "quote-city", value: customerInfo.city || "" },
    { id: "quote-state", value: customerInfo.state || "" },
    { id: "quote-zip", value: customerInfo.zip || "" },
    { id: "quote-suite-number", value: customerInfo.suite || "" }
  ];
  
  fieldsToTransform.forEach(field => {
    const element = document.getElementById(field.id);
    if (element) {
      const textSpan = document.createElement("span");
      textSpan.textContent = field.value;
      
      element.parentNode.replaceChild(textSpan, element);
    }
  });
  
  const countrySelect = document.getElementById("country-select");
  if (countrySelect && customerInfo.country) {
    const selectedOption = countrySelect.options[countrySelect.selectedIndex];
    const countryText = selectedOption ? selectedOption.textContent : customerInfo.country;

    const textSpan = document.createElement("span");
    textSpan.textContent = countryText;

    countrySelect.parentNode.replaceChild(textSpan, countrySelect);
  }

  const procurementSelect = document.getElementById("quote-procurement-status");
  if (procurementSelect) {
    const selectedOption = procurementSelect.options[procurementSelect.selectedIndex];
    const procurementText = selectedOption && selectedOption.value
      ? selectedOption.textContent
      : customerInfo.procurementStatus || "";

    const textSpan = document.createElement("span");
    textSpan.textContent = procurementText;
    textSpan.style.color = "#081A39";

    const procurementLabel = document.querySelector("label[for='quote-procurement-status']");
    if (procurementLabel) procurementLabel.removeAttribute("for");

    procurementSelect.style.display = "none";
    procurementSelect.parentNode.insertBefore(textSpan, procurementSelect.nextSibling);
  }
}

function hideInteractiveElements() {
  const submitBtn = document.getElementById("submit-quote");
  if (submitBtn) {
    submitBtn.style.display = "none";
  }
  
  const clearAddress = document.getElementById("quote-clear-address");
  if (clearAddress) {
    clearAddress.style.display = "none";
  }
  
  const shippingBtn = document.getElementById("quote-shipping-button");
  if (shippingBtn) {
    shippingBtn.style.display = "none";
  }
  
  const submitContainer = document.getElementById("quote-submit-container");
  if (submitContainer) {
    submitContainer.style.display = "none";
  }
}

function transformCartItemsToReadOnly() {
  document.querySelectorAll('.quote-cart-qty').forEach(input => {
    const quantity = input.value;
    const qtyText = document.createElement("span");
    qtyText.textContent = `QTY ${quantity}`;
    qtyText.style.cssText = "color: #000; font-size: 18px;";

    
    const quantityContainer = input.closest('.quote-quantity-buttons');
    if (quantityContainer) {
      quantityContainer.parentNode.replaceChild(qtyText, quantityContainer);
    }
  });
  
  document.querySelectorAll('.remove-quote-item').forEach(btn => {
    btn.style.display = "none";
  });
  
  document.querySelectorAll('.quote-qty-increment, .quote-qty-decrement').forEach(btn => {
    btn.style.display = "none";
  });

  document.querySelectorAll('.quote-product-control').forEach(control => {
    control.style.justifyContent = "flex-end";
  });

  const quoteHeader = document.querySelector('.quote-overlay');
  if (quoteHeader) {
    quoteHeader.style.paddingTop = "0";
  }
}

function transformNotesToReadOnly() {
  const notesTextarea = document.getElementById("quote-notes");
  if (notesTextarea) {
    const notesValue = notesTextarea.value || sessionStorage.getItem("quoteNotes") || "";
    
    if (notesValue.trim()) {
      const notesDisplay = document.createElement("div");
      notesDisplay.textContent = notesValue;
      
      notesTextarea.parentNode.replaceChild(notesDisplay, notesTextarea);
    } else {
      const notesSection = notesTextarea.closest('.quote-notes-section');
      if (notesSection) {
        notesSection.style.display = "none";
      }
    }
  }
}

function showSelectedShippingOption() {
  const shippingContainer = document.getElementById("shipping-methods-container");
  if (shippingContainer) {
    shippingContainer.innerHTML = "";
    
    const selectedOption = sessionStorage.getItem("selectedShippingOption");
    const selectedRate = sessionStorage.getItem("selectedShippingRate");
    
    if (selectedOption) {
      const selectedDisplay = document.createElement("div");
      
      const formattedRate = selectedRate ? `$${parseFloat(selectedRate).toFixed(2)}` : "";
      selectedDisplay.innerHTML = `
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <span style="color: #000; font-size: 1.5rem;">${selectedOption}</span>
          <span style="color: #000; font-size: 1.5rem; font-weight: 600;">${formattedRate}</span>
        </div>
      `;
      
      shippingContainer.appendChild(selectedDisplay);
    }
  }
}

function updateHeaderForConfirmation() {
  const header = document.querySelector('.quote-header-left h2');
  if (header) {
    header.textContent = "Quote Request Submitted";
    header.classList.add("success");
  }
  
  const subheader = document.createElement('span');
  subheader.textContent = "A copy of this quote will be emailed to you. You can expect to receive your quote in 1-2 business days. Contact sales@msesupplies.com with questions";
  subheader.style.cssText = "color: #000; font-size: 18px;";
  header.parentNode.insertBefore(subheader, header.nextSibling);

  const keepShoppingBtn = document.getElementById('keep-shopping-header');
  keepShoppingBtn.remove();

  const actionsContainer = document.querySelector('.quote-actions-container');
  if (actionsContainer) {
    actionsContainer.classList.remove("hidden");
  }
}

window.showSubmittedQuotePage = showSubmittedQuotePage;

window.addEventListener("quoteSubmittedSuccessfully", () => {
  console.log("Received quote submission success event, transforming page...");
  
  // Save current quoteCart as submittedQuoteCart before clearing
  const currentQuoteCart = sessionStorage.getItem("quoteCart");
  if (currentQuoteCart) {
    sessionStorage.setItem("submittedQuoteCart", currentQuoteCart);
  }
  
  showSubmittedQuotePage();
  
  if (typeof window.clearQuoteStorage === 'function') {
    window.clearQuoteStorage(true); // preserve submittedQuoteCart
  }
});

window.addEventListener("quoteCartUpdated", updateCartSummary);
